const isProd = !/sandbox|localhost|127\.0.0.1|10.1.200|10.1.161/i.test(location.hostname);
// const isSgp = /seeronnet/i.test(location.hostname);
// const serviceNodeUrlOpt = {
//   cn: {
//     dev: 'https://sandbox-api-unify.lingjiptai.com',
//     prod: 'https://api-unify.lingjiptai.com',
//   },
//   sgp: {
//     dev: 'https://sandbox-api-unify.seeronnet.com',
//     prod: 'https://api-unify.seeronnet.com',
//   }
// }

const getUrl = () => {
  return isProd ? 'https://api-unify.seeronnet.com' : 'https://sandbox-api-unify.seeronnet.com';
};

const pathList = [
  {
    name: 'base',
    baseUrl: getUrl(),
    paths: {
      login: '/login',
      loginV2: '/login_v2',
      reSMS: '/resend/sms',
      verifySMS: '/verify/sms',
      userInfo: '/user/info',
      userInfoByAuthCode: '/info_by_code',
      userBackend: '/user/backend',
      getToken: '/user/backend/token',
      sort: '/user/backend/sort',
      getCode: '/danger/send/sms',
      getDangerState: '/danger/state',
      dangerLogin: '/danger/login',
      dingdignCompany: '/api/backends/company',
      fingerprintSendSMS: '/fingerprint/send/sms',
      fingerprintVerifySMS: '/fingerprint/verify/sms',
    },
  },
  {
    name: 'admin',
    baseUrl: getUrl(),
    paths: {
      user: '/user',
      userList: '/user/simple',
      syncUser: '/user/sync',
      backend: '/backend',
      backendList: '/backend/simple',
      banUser: '/user/enable_or_disable',
    },
  },
  {
    name: 'log',
    baseUrl: getUrl(),
    paths: {
      loginLog: '/user/login/log',
      visitLog: '/user/visit/log',
      backendLog: '/user/backend/log',
      authLog: '/api/authentication/logs',
      permissionPointLog: '/api/permission_point/logs',
    },
  },

  {
    name: 'tree',
    baseUrl: getUrl(),
    paths: {
      getBackendTree: '/api/permission_point/tree',
      sortTree: '/api/permission_point/sort',
    },
  },
  {
    name: 'authPoint',
    baseUrl: getUrl(),
    paths: {
      createAuthPoint: '/api/permission_point/create',
      delAuthPoint: '/api/permission_point/delete',
      updateAuthPoint: '/api/permission_point/update',
      getAuthPoint: '/api/permission_point/info',
      updatePointApi: '/api/permission_point/update/api',
    },
  },
  {
    name: 'auth',
    baseUrl: getUrl(),
    paths: {
      backendUser: '/api/permission_point/user/backend',
      backendUserSimple: '/api/permission_point/backend/user',
      userBackendAuth: '/api/permission_point/user/tree',
      setUserAuth: '/api/permission_point/empower',
      getAuthUser: `/api/permission_point/users`,
      batchAuthUser: `/api/permission_point/v2/empower/users`,
    },
  },
  {
    name: 'notification',
    baseUrl: getUrl(),
    paths: {
      getUnreadCount: '/api/notification/message/unread_count',
      notification: '/api/notification',
      message: '/api/notification/message',
      checkSensitiveWords: '/api/notification/check_sensitive_words',
      getDepartmentUsers: '/api/notification/department/users',
    },
  },
];
// 导出时对象为
// {
//   setting: {
//      getList:base + '',
//   },
//   ...
// }
let obj = {};
pathList.forEach((i) => {
  const base = i.baseUrl || getUrl();
  for (var key in i.paths) {
    if (i.paths.hasOwnProperty(key)) {
      i.paths[key] = base + i.paths[key];
    }
  }
  obj[i.name] = i.paths;
});
export default obj;
